import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSnsYoutube(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "21",
    height: "15",
    fill: "none",
    viewBox: "0 0 21 15",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#8B8D92",
    fillRule: "evenodd",
    d: "M18.037.761c.625.117 1.21.47 1.555.922 1.192 1.88 1.294 10.352-.194 11.842a2.6 2.6 0 0 1-1.39.711c-5.839.44-13.613.264-15.123-.047-.54-.108-1.008-.351-1.352-.703-.265-.265-.476-.671-.64-1.235-.388-1.298-.894-9.321.718-10.818A2.66 2.66 0 0 1 2.94.761C4.77.413 16.206.413 18.037.761M8.488 4.475v5.612l1.209-.619c1.533-.784 2.956-1.51 4.151-2.174-.524-.28-1.025-.555-1.52-.826-1.228-.673-2.42-1.326-3.84-1.993",
    clipRule: "evenodd"
  }));
}
var IcSnsYoutube = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSnsYoutube));

export { IcSnsYoutube as I };
